var base;

require('core-js/fn/array/find');

require('core-js/fn/array/find-index');

require('core-js/fn/object/keys');

require('core-js/fn/object/assign');

require('core-js/fn/string/includes');

require('picturefill');

require('dom4');

document.head || (document.head = document.getElementsByTagName('head')[0]);

(base = window.location).origin || (base.origin = window.location.protocol + "//" + window.location.host);


/*
 * Chrome requestIdleCallback() shim: https://gist.github.com/paullewis/55efe5d6f05434a96c36
 */

window.requestIdleCallback = window.requestIdleCallback || function(cb) {
  return setTimeout((function() {
    var start;
    start = Date.now();
    return cb({
      didTimeout: false,
      timeRemaining: function() {
        return Math.max(0, 50 - (Date.now() - start));
      }
    });
  }), 1);
};


/*
 * Chrome cancelIdleCallback() shim: https://gist.github.com/paullewis/55efe5d6f05434a96c36
 */

window.cancelIdleCallback = window.cancelIdleCallback || function(id) {
  return clearTimeout(id);
};

Array.prototype.move = function(from, to) {
  this.splice(to, 0, this.splice(from, 1)[0]);
  return this;
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvc3JjL2Zyb250ZW5kL2NvcmUvZG9tX2pzX3NoaW0uY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvc3JjL2Zyb250ZW5kL2NvcmUvZG9tX2pzX3NoaW0uY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsT0FBQSxDQUFRLHVCQUFSOztBQUNBLE9BQUEsQ0FBUSw2QkFBUjs7QUFDQSxPQUFBLENBQVEsd0JBQVI7O0FBQ0EsT0FBQSxDQUFRLDBCQUFSOztBQUNBLE9BQUEsQ0FBUSw0QkFBUjs7QUFDQSxPQUFBLENBQVEsYUFBUjs7QUFFQSxPQUFBLENBQVEsTUFBUjs7QUFHQSxRQUFRLENBQUMsU0FBVCxRQUFRLENBQUMsT0FBUyxRQUFRLENBQUMsb0JBQVQsQ0FBOEIsTUFBOUIsQ0FBc0MsQ0FBQSxDQUFBOztRQUd4RCxNQUFNLENBQUMsU0FBUSxDQUFDLGVBQUQsQ0FBQyxTQUFXLE1BQU0sQ0FBQyxRQUFRLENBQUMsUUFBaEIsR0FBMkIsSUFBM0IsR0FBa0MsTUFBTSxDQUFDLFFBQVEsQ0FBQzs7O0FBRzdFOzs7O0FBR0EsTUFBTSxDQUFDLG1CQUFQLEdBQTZCLE1BQU0sQ0FBQyxtQkFBUCxJQUE4QixTQUFDLEVBQUQ7U0FDekQsVUFBQSxDQUFXLENBQUMsU0FBQTtBQUNWLFFBQUE7SUFBQSxLQUFBLEdBQVEsSUFBSSxDQUFDLEdBQUwsQ0FBQTtXQUNSLEVBQUEsQ0FDRTtNQUFBLFVBQUEsRUFBWSxLQUFaO01BQ0EsYUFBQSxFQUFlLFNBQUE7ZUFBRyxJQUFJLENBQUMsR0FBTCxDQUFTLENBQVQsRUFBWSxFQUFBLEdBQUssQ0FBQyxJQUFJLENBQUMsR0FBTCxDQUFBLENBQUEsR0FBYSxLQUFkLENBQWpCO01BQUgsQ0FEZjtLQURGO0VBRlUsQ0FBRCxDQUFYLEVBTUcsQ0FOSDtBQUR5RDs7O0FBUzNEOzs7O0FBR0EsTUFBTSxDQUFDLGtCQUFQLEdBQTRCLE1BQU0sQ0FBQyxrQkFBUCxJQUE2QixTQUFDLEVBQUQ7U0FBUSxZQUFBLENBQWEsRUFBYjtBQUFSOztBQUd6RCxLQUFLLENBQUEsU0FBRSxDQUFBLElBQVAsR0FBYyxTQUFDLElBQUQsRUFBTyxFQUFQO0VBQ1osSUFBSSxDQUFDLE1BQUwsQ0FBWSxFQUFaLEVBQWdCLENBQWhCLEVBQW1CLElBQUksQ0FBQyxNQUFMLENBQVksSUFBWixFQUFrQixDQUFsQixDQUFxQixDQUFBLENBQUEsQ0FBeEM7QUFDQSxTQUFPO0FBRksifQ==
